import { DialogProps } from "@/types/ui";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useMutation } from "@tanstack/react-query";
import PaymentFields from "@/components/ui/culqi/payment-fields";
import { router, usePage } from "@inertiajs/react";
import { AuthenticatedUserProp } from "@/types";
import { post } from "@/lib/api";
import useTranslations from "@/hooks/use-translations";

export default function UpdatePaymentDetailsDialog({
  open,
  onOpenChange,
}: DialogProps) {
  const currentPage = usePage<AuthenticatedUserProp>();
  const { current_user, culqi_public_key } = currentPage.props;
  const { t } = useTranslations("shared.components.update_payment_details_dialog");
  const updatePaymentDetailsMutation = useMutation({
    mutationFn(token: string) {
      return post("billing/payment_details", { token });
    },
    onSuccess() {
      router.visit(currentPage.url, { preserveState: true });
    },
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("title")}</DialogTitle>
        </DialogHeader>

        <PaymentFields
          publicKey={culqi_public_key}
          email={current_user.email}
          currency="USD"
          className="h-120"
          onComplete={(token) => updatePaymentDetailsMutation.mutate(token)}
        />
      </DialogContent>
    </Dialog>
  );
}
